/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GradingStatsReport } from './gradingStatsReport';

export type GenericApiResponseGradingStatsReportData = GradingStatsReport | null;
